// extracted by mini-css-extract-plugin
export default {"table_wrapper":"chat-table_table_wrapper__wkrYU"};